<app-frame-3
  appPageTitle="Sitemule"
  appFavicon="../../../../assets/images/sitemule-logo.png"
  [links]="topNavigation"
  [content]="content"
  [contacts]="contacts"
  logo="sitemulelogo"
  logoLink="/"
  logoName="Sitemule"
  logoSlogan="evolve your business while holding on to the core"
  logoSloganMobile="evolve your business"
  copyRightInfo="Sitemule is a trademark by System & Method A/S. All rights reserved ©2022"
  [ngStyle]="{ '--primary-color': 'rgb(0, 161, 253)' }"
  type="Sitemule"
  [style.--nav-background-color]="'transparent'"
  [style.--text-color]="'#000'"
  [style.--icon-color]="'#000'"
  [style.--special-button-text-color]="'rgb(0, 161, 253)'"
  [style.--special-button-background-color]="'transparent'"
  [style.--special-button-border-color]="'none'"
  [style.--footer-background-color]="'#0F1112'"
  [style.--copy-right-color]="'#72787E'"
  [style.--footer-navbar-background-color]="'#0f1112'"
>
  <app-background-scroll-animator
    [images]="images"
  ></app-background-scroll-animator>
  <div
    id="hero"
    class="app-customer-demand"
    [style]="{
      height: '100vh',
      paddingLeft: 'var(--content-margin, 0)',
      paddingRight: 'var(--content-margin, 0)',
      paddingBlock: '20vh',
      display: 'flex'
    }"
  >
  <app-stretchable-text [initialFontSize]="initialFontSize" style="flex: 1;max-width: 100%;">
    <ngx-typed-js
      *ngIf="isPlatformBrowser"
      [typeSpeed]="40"
      [backSpeed]="10"
      [startDelay]="150"
      [strings]="[
        'finance',
        'insurance',
        'construction',
        'manufacturing',
        'wholesale',
        'retail',
        'transportation',
        'business services'
      ]"
      [loop]="true"
      [backDelay]="1500"
    >
        <h3
          [style]="{
            color: '#fff',
            margin: 0
          }"
        >
          We do integration transformation and innovation<br />
          for <span class="typing"></span>
        </h3>
      </ngx-typed-js>
    </app-stretchable-text>
  </div>
  <sm-container
    id="integration"
    appSneakPeak="app-web-based-service"
    [sneakPeakHeight]="-150"
    class="app-web-based-service-integration"
  >
    <app-web-based-service
      header="Integrate to adapt as market shift focus"
      description="Integration is the cheapest and fastest way for your business to adapt to ever-changing markets and customers. It will create fundamental changes in how you conduct your business.
      <br />  <br /> Sitemule executes integration in your IT while keeping your business steady as a rock adding value through new functionalities and services.

       "
      [style.--background-color]="'transparent'"
      [style.--inner-container-width]="'900px'"
      [style.--content-position]="'flex-start'"
    >
    </app-web-based-service>
  </sm-container>
  <sm-container
    id="transformation"
    class="app-web-based-service-transformation"
  >
    <app-web-based-service
      header="Transform to become more competitive"
      description="IT transformation will improve the speed of your development while significantly reducing the risk of project failures. In other words - your power to compete depends on the strength of your digital infrastructure.
      <br /> <br />Sitemule executes transformations delivering compliant and solid infrastructure while keeping your business steady as a rock and adding value with IT stability."
      [style.--background-color]="'transparent'"
      [style.--inner-container-width]="'900px'"
      [style.--content-position]="'flex-start'"
    >
    </app-web-based-service>
  </sm-container>
  <sm-container id="innovation" class="app-web-based-service-innovation">
    <app-web-based-service
      header="Innovate for user convenience"
      description="Digital innovation is always about delivering a better experience or a brand-new one. Pleasing users is how you hold on to them may it be your customers or employees. And the effort will most likely put your business in a unique competitive situation.
      <br /> <br />
      Sitemule executes digital innovation by evaluating risk and effort against the expected result. In the attempt to help your business to make consciously competent decisions."
      [style.--background-color]="'transparent'"
      [style.--inner-container-width]="'900px'"
      [style.--content-position]="'flex-start'"
    >
    </app-web-based-service>
  </sm-container>
  <sm-container
    id="relations"
    class="app-customers"
    [style]="{
      backgroundColor: 'rgba(206, 215, 215, 1)',
      minHeight: '100vh'
    }"
  >
    <app-customers
      header="Our relationships"
      [customers]="customers"
      [style.--header-text-color]="'#170700'"
      [style.--description-background-color]="'rgba(0, 0, 0, .9);'"
    ></app-customers>
    <div class="content">
      <app-image-animation
        imagePath="../../../../assets/images/coffee-cup.png"
        altText="coffee cup text"
      ></app-image-animation>
      <div class="links-container center big-top-margin" sm-technical-button>
        <a
          routerLink="/"
          fragment="lets-have-a-talk"
          [style.--border-radius]="'36px'"
          [style.--background-color]="'rgb(0, 161, 253, .8)'"
          [style.--hover-background-color]="'rgba(0, 161, 253, 1)'"
          [style.--button-text-color]="'#fff'"
        >
          Let's talk
        </a>
      </div>
      <p class="note">
        No sales BS. Just about making business better through technology.
      </p>
    </div>
  </sm-container>

  <sm-container
    id="technical"
    class="app-technical"
    [animateOnScroll]="true"
    [style.--background-color]="'rgba(44, 142, 39, 1)'"
    [style.--linear-gradient-animation]="
      'linear-gradient(179.71deg, rgba(44, 142, 39, .89) 0%, rgba(44, 142, 39, .89) 100%), url(../../../../../../assets/images/letsgettechnical.jpg)'
    "
  >
    <app-technical
      header="Dive into our Github"
      description="Get insights from Sitemules Github repositories."
      [style.--text-color]="'#fff'"
      [style.--max-content-width]="'1440px'"
      [style.--border-radius]="'36px'"
    >
      <div class="links-container center big-top-margin" sm-technical-button>
        <a
          target="_blank"
          [ngClass]="{ icon: link.icon }"
          *ngFor="let link of githubLink"
          [href]="link.href"
          [style.--border-radius]="link.borderRadius"
          [style.--background-color]="link.backgroundColor"
          [style.--hover-background-color]="'#fff'"
          [style.--button-text-color]="link.color"
        >
          <span *ngIf="link.icon" [smSvgIcon]="link.icon"></span>
          {{ link.label }}
        </a>
      </div>
    </app-technical>
  </sm-container>

  <sm-container
    id="team"
    class="app-persons"
    [style]="{
      backgroundColor: '#04162D'
    }"
  >
    <app-persons
      id="sitemule-team"
      header="We love to hear from you"
      [allPersons]="allPersons"
      [style.--header-color]="'#969EA7'"
      [style.--text-color]="'#FFFFFF'"
      [style.--person-background-color]="'#1C2C3F'"
      [style.--person-column-number]="3"
    ></app-persons>
  </sm-container>
  <sm-container class="sitemule-model-studio-video">
    <app-youtube-modal
      #youtubeRef
      [youtubeLink]="'https://www.youtube.com/watch?v=2YJU3HRV3EY'"
      [thumbnail]="'/assets/images/sitemule-model-studio-video-thumbnail.png'"
    ></app-youtube-modal>
    <h3 class="h3">If you ask the users - they would say...</h3>
    <p class="h3__subheader">
      See what's possible with Sitemule Model Studio in five minutes.
    </p>
    <div class="demo-section">
      <button sitemule-button borderRadius="30px" [color]="'icebreak'" [size]="'lg'" [mobileTabletSize]="'md'" [textSize]="'20px'" (click)="showYoutubeModal()">
        <span smSvgIcon="play_outline_none" style="--text-color: var(--text-color-white, white)"></span>
        Play Now
      </button>
      <a sitemule-button borderRadius="30px" [color]="'icebreak'" [size]="'lg'" [mobileTabletSize]="'md'" [textSize]="'20px'" [stroked]="true" routerLink="/download">
        <span smSvgIcon="file_download_icon"></span>
        Download Model Studio
      </a>
    </div>
  </sm-container>
  <sm-container
    id="lets-have-a-talk"
    class="contact-form"
    [style]="{
      backgroundColor: '#ebeced'
    }"
  >
    <app-contact-form
      header="Contact"
      subHeader="We will respond within 24 hours"
      type="sitemule"
    ></app-contact-form>
  </sm-container>
</app-frame-3>
